module.exports = __webpack_public_path__ + "img/no-files.b66714e7.svg";